import SellerTypeCard from "../../../component/seller/SellerTypeCard";
import style from "./SellerType.module.scss"

export default function SellerType() {
    console.log("url is", window.location.pathname)
    return (
        <div className={style.layout}>
            <SellerTypeCard/>
            <SellerTypeCard/>

        </div>
    )
}